<svg viewBox="0 0 40 75" fill="none" xmlns="http://www.w3.org/2000/svg" {...$$restProps}>
	<g clip-path="url(#clip0_3357_3046)">
		<path
			d="M32.2598 69.2691C29.3132 65.5315 23.8909 64.8897 20.1532 67.8362C23.0997 71.5739 28.5221 72.2157 32.2598 69.2691Z"
			fill="white"
		/>
		<path
			d="M33.6765 65.767C37.0418 62.4017 37.0418 56.9416 33.6765 53.5763C30.3112 56.9416 30.3112 62.4017 33.6765 65.767Z"
			fill="white"
		/>
		<path
			d="M24.9106 58.7555C28.8624 56.103 29.9164 50.7455 27.264 46.7937C23.3122 49.4462 22.2582 54.8037 24.9106 58.7555Z"
			fill="white"
		/>
		<path
			d="M16.6113 51.6571C21.0385 49.9101 23.2127 44.9014 21.4657 40.4742C17.0385 42.2213 14.8643 47.2299 16.6113 51.6571Z"
			fill="white"
		/>
		<path
			d="M11.4604 39.8202C16.2199 39.8202 20.0808 35.9592 20.0808 31.1998C15.3214 31.1998 11.4604 35.0607 11.4604 39.8202Z"
			fill="white"
		/>
		<path
			d="M11.6021 26.7822C15.9561 28.7044 21.0475 26.7316 22.9696 22.3776C18.6156 20.4554 13.5242 22.4282 11.6021 26.7822Z"
			fill="white"
		/>
		<path
			d="M15.8257 15.6394C19.4421 18.7336 24.8858 18.3099 27.98 14.6935C24.3636 11.5994 18.9198 12.023 15.8257 15.6394Z"
			fill="white"
		/>
		<path
			d="M21.448 61.4496C18.8169 57.4835 13.4652 56.4005 9.49912 59.0316C12.1302 62.9976 17.4819 64.0806 21.448 61.4496Z"
			fill="white"
		/>
		<path
			d="M13.7363 52.1978C12.7188 47.5484 8.12164 44.6021 3.47226 45.6197C4.4898 50.2691 9.08695 53.2153 13.7363 52.1978Z"
			fill="white"
		/>
		<path
			d="M8.91553 39.6808C9.49556 34.9568 6.1339 30.6541 1.40995 30.0741C0.829925 34.7981 4.19158 39.1008 8.91553 39.6808Z"
			fill="white"
		/>
		<path
			d="M8.48584 25.7293C10.8656 21.6075 9.45234 16.3333 5.33056 13.9536C2.95085 18.0754 4.36405 23.3495 8.48584 25.7293Z"
			fill="white"
		/>
		<path
			d="M13.3398 14.2751C16.8768 11.0904 17.1626 5.63768 13.9779 2.10074C10.4409 5.28541 10.1552 10.7382 13.3398 14.2751Z"
			fill="white"
		/>
		<path
			d="M19.5425 9.11913C24.2891 9.46841 28.423 5.9012 28.7723 1.15461C24.0257 0.805325 19.8918 4.37253 19.5425 9.11913Z"
			fill="white"
		/>
	</g>
	<defs>
		<clipPath id="clip0_3357_3046">
			<rect
				width="39.4125"
				height="74.084"
				fill="white"
				transform="matrix(-1 0 0 1 39.772 0.521973)"
			/>
		</clipPath>
	</defs>
</svg>
